import {createSelector} from 'reselect';
import {Store} from '../../../redux/reducers';
import {initialState} from './reducer';

const select = (state: Store) => state.invoices || initialState;

const makeSelectInvoicesList = () =>
  createSelector(select, substate => substate.invoicesList);

const makeSelectInvoicesFile = () =>
  createSelector(select, substate => substate.invoicesFile);

const makeSelectAllInvoicesList = () =>
  createSelector(select, substate => substate.allInvoicesList);

const makeSelectLogs = () => createSelector(select, substate => substate.logs);

const makeSelectCountList = () =>
  createSelector(select, substate => substate.count);

const makeSelectLoading = () =>
  createSelector(select, substate => substate.loading);

const makeSelectError = () =>
  createSelector(select, substate => substate.error);

export default select;
export {
  makeSelectLogs,
  makeSelectLoading,
  makeSelectCountList,
  makeSelectError,
  makeSelectInvoicesList,
  makeSelectAllInvoicesList,
  makeSelectInvoicesFile,
};
